import React, { useContext, useMemo } from 'react';

import {
	getAudienceScopeKey,
	useRovoTargetingAudienceAcquisition,
} from './acquireRovoTargetingAudience';
import { RovoTargetingAudienceContext } from './RovoTargetingAudienceContext';
import type { AudienceScope, RovoTargetingOperationalEventHandler } from './types';

export type RovoTargetingAudienceProviderProps = React.PropsWithChildren<AudienceScope>;

export const RovoTargetingAudienceProvider = ({
	children,
	productKey,
	accountId,
	siteId,
	hasRovoAccess,
	gateEnabled,
}: RovoTargetingAudienceProviderProps): JSX.Element => {
	const contextValue = useMemo(() => {
		const scope = { productKey, accountId, siteId, hasRovoAccess, gateEnabled };
		return { ...scope, scopeKey: getAudienceScopeKey(scope) };
	}, [productKey, accountId, siteId, hasRovoAccess, gateEnabled]);
	return (
		<RovoTargetingAudienceContext.Provider value={contextValue}>
			{children}
		</RovoTargetingAudienceContext.Provider>
	);
};

// Separate initialization from audience context so its analytics source applies only to
// readiness events, never to the Chat UI or intervention children.
export const RovoTargetingAudienceInitializer = ({
	emit,
}: {
	emit: RovoTargetingOperationalEventHandler;
}): null => {
	const scope = useContext(RovoTargetingAudienceContext);
	useRovoTargetingAudienceAcquisition(scope, emit);
	return null;
};
